import { Grid } from '@yuno/design-system-web'
const AccountMenuTooltip = ({ account, profile }) => {
  return (
    <Grid>
      <Grid>{`${account.name} - ${profile.rol_name}`}</Grid>
      <Grid>{profile.email}</Grid>
    </Grid>
  )
}

export default AccountMenuTooltip
